// La sesión validada por el backend elige la credencial; no se busca por persona.
export function aplicarCredencialDocente(respuesta, token, colegioID, storage = localStorage) {
  const id = respuesta?.sesion?.DocenteID;
  if (!respuesta?.valido || respuesta.sesion.ColegioID !== colegioID ||
      storage.getItem('docente_token') !== token ||
      storage.getItem('colegio_seleccionado') !== colegioID ||
      !id || respuesta.docente?.id !== id || respuesta.docente?.docenteID !== id ||
      respuesta.docente?.categoria !== 'empleado') return false;
  const anterior = JSON.parse(storage.getItem('docente_data') || '{}');
  const actual = { ...anterior, ...respuesta.docente };
  delete actual.docenteOrigenID;
  const origen = respuesta.sesion.DocenteOrigenID;
  if (typeof origen === 'string' && origen.trim()) actual.docenteOrigenID = origen;
  storage.setItem('docente_data', JSON.stringify(actual));
  return true;
}

// El ancla viene de la sesión validada; el servidor decide su destino por fecha.
export function docenteParaFecha(docenteID, colegioID, fecha, sesion) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(fecha || '') || sesion?.colegioID !== colegioID) return docenteID;
  const docente = sesion?.docente;
  const propios = [docente?.id, docente?.docenteID, docente?.docenteOrigenID].filter(Boolean);
  return propios.includes(docenteID) && docente?.docenteOrigenID ? docente.docenteOrigenID : docenteID;
}
